import ExhibitionTimeBlock from "./exhibition-time-block";

import "./exhibition-blocks.scss";


const ExhibitionBlocks = {
    Time : ExhibitionTimeBlock
}

export default ExhibitionBlocks;